import React from 'react';
import ImportantMessageBox from '../../messagesScreen/ImportantMessageBox';

export const NotSupportedMessage = () => {
    return (
        <div className="main-container messages-main-container basic-layering">
            <ImportantMessageBox icon="alert-red" color="red-box" message="identity-videoCallBrowserNotAllowed" />
        </div>
    );
};
